import React, { Component } from 'react'
import T from 'i18n-react'

import TableComponent from 'components/custom/TableV2'

import CollapsableCard from 'components/custom/Card/CollapsableCard'

import buildProgressHoc from 'containers/Async/AsyncProgressBarHoc'

import {FETCH_GREENLIGHT_REPORT} from "./constants";

const Table = buildProgressHoc(TableComponent)([ FETCH_GREENLIGHT_REPORT ])

// const model = {
//   project: {type: String, title: 'Project ID'},
//   revision: {type: String, title: 'Report Revision'},
//   status: {type: String, title: 'Status'},
//   partnerSite: {type: String, title: 'Partner Site'},
//   partner: {type: String, title: 'Partner'},
//   boostClock: {type: String, title: 'Boost Clock'},
//   vfOffset: {type: String, title: 'VF Offset'},
//   minTgp: {type: String, title: 'minTGP'},
//   acousticIdle: {type: String, title: 'Idle - Acoustics'},
//   gpuTempIdle: {type: String, title: 'Idle - GPU Tj'},
//   acousticSingle: {type: String, title: 'Single Card - Acoustics'},
//   gpuTempSingle: {type: String, title: 'Single Card - GPU Tj'},
//   acousticSli: {type: String, title: 'SLI - Acoustics'},
//   gpuTempSli: {type: String, title: 'SLI - GPU Tj'},
// }

const tableHeadContent = {
  project: 'Project ID',
  revision: 'Report Revision',
  status: 'Status',
  partnerSite: 'Partner Site',
  partner: 'Partner',
  boostClock: 'Boost Clock',
  vfOffset: 'VF Offset',
  minTgp: 'minTGP',
  acousticIdle: 'Idle - Acoustics',
  gpuTempIdle: 'Idle - GPU Tj',
  acousticSingle: 'Single Card - Acoustics',
  gpuTempSingle: 'Single Card - GPU Tj',
  acousticSli: 'SLI - Acoustics',
  gpuTempSli: 'SLI - GPU Tj',
  totalCardDimensionX: 'Total Card Dimension X',
  totalCardDimensionY: 'Total Card Dimension Y',
  totalCardDimensionZ: 'Total Card Dimension Z'
}

const ReportSummaryCard = ({reportSource, tableFilter, tableSort, sku,  onInputChange, searchFilter, removeFilter, onClearFilters, onRowClick, onMenuSubmit}) => (
  <CollapsableCard title={T.translate('containers.report.greenlight.table.header')} collapse={true} onRefresh={onClearFilters}>
    {sku ? <Table
      selectable={false}
      source={reportSource}
      onRowClick={onRowClick}
      onInputChange={onInputChange}
      searchFilter={searchFilter}
      removeFilter={removeFilter}
      onMenuSubmit={onMenuSubmit}
      tableFilter={tableFilter}
      tableSort={tableSort}
      tableHeadContent={tableHeadContent}
      csvFilename={sku + ' GL.csv'}
    /> : <div></div>}
  </CollapsableCard>
)

export default ReportSummaryCard